/// <reference types="./InitializationContext.d.ts" />
import { TransactionContextImpl, } from '@dossierhq/database-adapter';
class InitializationContext extends TransactionContextImpl {
    constructor(databaseAdapter, logger, databasePerformance, transaction) {
        super(databaseAdapter, logger, databasePerformance, transaction);
    }
    copyWithNewTransaction(databaseAdapter, transaction) {
        return new InitializationContext(databaseAdapter, this.logger, this.databasePerformance, transaction);
    }
}
export function createInitializationContext(databaseAdapter, logger, databasePerformance) {
    return new InitializationContext(databaseAdapter, logger, databasePerformance, null);
}
//# sourceMappingURL=InitializationContext.js.map